export function getEnv(key: string): string {
  const value = import.meta.env[key]
  // Always lowercase APP_ENV to account for potentially mixed case or faulty variable settings
  if (key === 'VITE_APP_ENV') return value ? value.toLowerCase() : 'development'
  return value
}
